/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NameChangeHistoryResponse {
    getFixupPrototypeFunction() { return NameChangeHistoryResponse.fixupPrototype; }

    static newInstance(model: Partial<NameChangeHistoryResponse>): NameChangeHistoryResponse {
        let obj = Object.assign(new NameChangeHistoryResponse(), model);
        NameChangeHistoryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NameChangeHistoryResponse>): NameChangeHistoryResponse {
        if (!model) return null;
        return NameChangeHistoryResponse.newInstance(<NameChangeHistoryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NameChangeHistoryResponse) {
        if (!obj) return;

        models.NameChangeHistoryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NameChangeHistoryResponse): boolean {
        Object.setPrototypeOf(obj, NameChangeHistoryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.name_change_history) {
            for (let val of this.name_change_history) {
                models.NameChangeHistoryEntry.fixupPrototype(val);
            }
        }
    }

    /**
     * List of tenant name changes in reverse chronological order.
     */
    name_change_history: Array<models.NameChangeHistoryEntry>;

}
